"use client"

import React from "react"
import Details from "@/components/work/Details"
import Post from "@/components/post/Post"
import { useScreenType } from "@/contexts/ScreenTypeContext"

export default function ScreenBehaviour({ formattedPost, nextPost, type }) {

  const { screenType, isBigscreen } = useScreenType()

  if (screenType === "loading") {
    return <div className="flex items-center justify-center w-screen h-screen">Loading screen information...</div> 
  }

  return !isBigscreen ? <Post data={formattedPost} previous={nextPost} type={type} /> : <Details data={formattedPost} previous={nextPost} type={type} />
}
